<template>
  <div class="main-page page-listone">
    <Menu :title="title"
          :home="true" />
    <div class="container-flex wrap-list">
      <div class="left-list"
           v-if="list.length">
        <div :class="['item',index==current?'active':''] "
             @click="getDetail(news,index)"
             v-for="(news,index) in list"
             :key="'key-list'+index">
          {{news.title}}
        </div>
      </div>
      <div class="right-con"
           v-if="isload">
        <template v-if="ispdf">
          <Pdf v-model="pdf"
               v-if="pdf.show"></Pdf>
        </template>
        <template v-if="!ispdf">
          <div class="content"
               v-if="article">
            <div class="title">
              {{article.title}}
            </div>
            <div class="time">
              <template v-if="article.author">来源：{{article.author }} &nbsp;&nbsp;|&nbsp;&nbsp; </template>
              时间： {{article.date}}
            </div>
            <div class="detail"
                 v-html="article.detail"
                 v-if="article.detail" />
          </div>
          <div class="emptyinfo"
               v-if="!article">
            <img src="/img/ui/emptyinfo1.png"
                 alt="">
            <p v-if="list.length > 0">请点击左边文章查看详情</p>
            <p v-else>暂无内容</p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '../components/Menu'
import api from '../datas/js/api.js'
import Pdf from '../components/PDF'
import { NOTICE } from '../datas/constants/statistics.js'
export default {
  components: {
    Menu,
    Pdf
  },
  data () {
    return {
      title: '',
      list: [],
      isload: false,
      current: -1,
      article: '',
      ispdf: false, // pdf
      pdf: {
        show: false,
        url: ''
      }
    }
  },

  methods: {
    async getDetail (item, index) {
      this.pdf.show = false
      $('.right-con').scrollTop(0, 2000); // eslint-disable-line
      this.current = index
      let url = api.post + item.id + `&machine_id=${this.$store.state.device.point.no}&platform=ZD`
      if (this.$route.query.id === '61304a8c0c4886185ed79f0f') {
        url = `https://publaw.12348.lvpin100.com/api/post/view/?post_id=${item.id}&code=530000`
      }
      const { status, result, msg } = await this.$get(url, this)
      if (!status) {
        console.log(msg)
        return
      }
      if (result.data.file && result.data.file.length) {
        this.ispdf = true
        this.ininPdf(result.data.file)
      } else {
        this.ispdf = false
        this.article = result.data
      }
    },
    ininPdf (file) {
      this.pdf.url = file[0].url
      this.pdf.show = true
    }
  },
  async mounted () {
    const { id, title, minority } = this.$route.query
    if (NOTICE[id]) {
      // 数据统计
      this.$root.getStatistics(NOTICE[id])
    }
    if (title) {
      this.title = title
    }
    if (minority === '9') {
      const { status, result, msg } = await this.$get(api.minorityList + id + '&post=post', this)
      this.isload = true
      // console.log('status', typeof (status))
      if (status !== 1) {
        console.log(msg)
        return
      }
      console.log('minority9', minority)
      this.list = result.items

      return
    }
    if (minority && minority !== '9') {
      const { status, result, msg } = await this.$get(api.minority + id, this)
      this.isload = true
      // console.log('status', typeof (status))
      if (status !== 1) {
        console.log(msg)
        return
      }
      this.list = result.items
      if (this.list.length) {
        // this.getDetail(this.list[0], 0)
      }
      return
    }
    if (!minority) {
      let url = api.list
      if (id === '61304a8c0c4886185ed79f0f') {

        url = `https://publaw.12348.lvpin100.com/api/post/list/?code=530000&per_page=500&diagram_id=`
      }
      const { status, result, msg } = await this.$get(url + id, this)
      this.isload = true
      if (!status) {
        console.log(msg)
        return
      }
      console.log('Nominority', minority)
      if (id === '5e7c0d5f9748ca3efb2de4fb') {
        this.list = result.data.items.reverse()
      } else {
        this.list = result.data.items
      }
      if (this.list.length) {
        this.getDetail(this.list[0], 0)
      }
    }
  }
}
</script>
<style lang="stylus" >
.page-listone
  .hide-terminal
    display none !important
  .wrap-list
    height 100%
    display flex
    justify-content center
    padding 0.09rem 0.6rem 0.5rem
    .left-list
      width 5rem
      height 100%
      margin-right 0.48rem
      background-color rgba(255, 255, 255, 0.2)
      border-radius 0.1rem
      border solid 1px rgba(255, 255, 255, 0.2)
      padding-bottom 1.3rem
      overflow-y scroll
      webkit-overflow-scrolling touch
      &::-webkit-scrollbar
        display none
        width 0 !important
      .item
        border-bottom solid 1px rgba(255, 255, 255, 0.2)
        color #fff
        padding 0.2rem
        line-height 1.6
        font-size 0.26rem
        &.active
          background #f29530
          border 0
    .right-con
      position relative
      height 100%
      width 12.46rem
      overflow-y scroll
      background #fff
      border-radius 0.1rem
      webkit-overflow-scrolling touch
      box-sizing border-box
      .content
        padding 0 0.9rem
      &::-webkit-scrollbar
        display none
        width 0 !important
      .title
        font-size 0.36rem
        color #333333
        font-weight 600
        padding 0.7rem 0 0.2rem 0
      .time
        font-size 0.18rem
        color #999
        margin-bottom 0.1rem
      .detail
        padding 0 0 0.45rem 0
        p
          margin 1em 0 !important
          font-size 0.22rem !important
          line-height 1.6
        span
          font-size 0.22rem !important
          line-height 1.6
        img
          max-width 100%
          display block
          margin 0 auto
        table
          width 100% !important
      .emptyinfo
        display flex
        flex-direction column
        justify-content center
        align-items center
        width 100%
        font-size 0.22rem
        color #999
        height 100%
        img
          display block
          margin-bottom 0.2rem
    .list-nav
      width 1.7rem
      height 9rem
      margin-left 0.4rem
      display flex
      flex-direction column
      justify-content flex-end
      .item
        height 1.1rem
        background-color #557dff
        border-radius 0.1rem
        color #fff
        font-size 0.22rem
        display flex
        flex-direction column
        justify-content center
        margin-top 0.15rem
        align-items center
        span
          font-weight 600
</style>
